import React from 'react';
import IconArrowRight from './IconArrowRight';
import TrackedLink from 'components/sanity/TrackedLink';

type ProductCalloutProps = {
  header: string;
  elementLabel?: string;
  linkHref: string;
  linkText: string;
  imgUrl: string;
  imgAlt?: string;
  trackerClass?: string;
  newTab?: boolean;
};

const ProductCallout = (props: ProductCalloutProps) => {
  return (
    <div className="space-y-16">
      <TrackedLink
        href={props.linkHref}
        className={`group inline-block ${props.trackerClass ? props.trackerClass : ''} `}
        elementLabel={props.elementLabel}
        {...(props.newTab && { target: '_blank', rel: 'noopener noreferrer' })}
      >
        <div className="aspect-ratio-5by7">
          <img
            loading="lazy"
            className="w-full max-w-[274px] transition duration-150 group-hover:shadow-3"
            src={`${props.imgUrl}?auto=format&w=274&fit=crop&ar=5:7&q=100`}
            alt={props.imgAlt}
          />
        </div>
      </TrackedLink>
      <TrackedLink
        href={props.linkHref}
        className={`block ${props.trackerClass ? props.trackerClass : ''}`}
        elementLabel={props.elementLabel}
      >
        <h3 className="text-h5">{props.header}</h3>
        <p className="text-sm flex items-center space-x-8">
          <span className="text-anchor">{props.linkText}</span>
          <IconArrowRight className="!text-gold-darker" />
        </p>
      </TrackedLink>
    </div>
  );
};

export default ProductCallout;
